import { ErrorMessage } from 'formik';
import React from 'react';
import './TemplateFormLabel.scss';

type Props = {
  title?: string;
  flex?: boolean;
  children: React.ReactNode;
};

const TemplateFormLabel = ({ title, children, flex }: Props) => {
  return (
    <label className="template-form__item">
      {title && <div className="template-form__label">{title}</div>}
      <div className={`template-form__content--flex_${flex}`}>{children}</div>
    </label>
  );
};

TemplateFormLabel.Error = ({ name }: { name: string }) => (
  <ErrorMessage name={name}>
    {msg => <div className="template-form__error">{msg}</div>}
  </ErrorMessage>
);
export { TemplateFormLabel };
